module.exports = __webpack_public_path__ + "img/Ac.aa0ecb72.jpg";